import {createAsyncThunk} from '@reduxjs/toolkit'

import {changeBrowserLocation, openPopup} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {NavigationResult, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

const OVERSEAS_SHOPPING_URL = 'https://www.customs.go.kr/kcs/ad/cntnts/cntntsView.do?cntntsId=10220&mi=10220'

const POPUP_KEY = 'OVERSEA_SHOPPING_KEY'

/**
 * 해외직구 페이지로 이동
 */
const navigateToOverseaShopping = createAsyncThunk<
    NavigationResult,
    NavigationTypeSelectableParam | void,
    ThunkApi<unknown>
>('navigateTo/overseaShopping', async (args) => {
    const {forceLocationChange = false} = args ?? {}
    const navigateByLocationChange = forceLocationChange || isMobile

    if (navigateByLocationChange) {
        changeBrowserLocation({url: OVERSEAS_SHOPPING_URL, type: 'PUSH'})

        return Promise.resolve()
    }

    await openPopup({
        key: POPUP_KEY,
        url: OVERSEAS_SHOPPING_URL,
        size: {
            width: 500,
            height: 640,
        },
    })

    return Promise.resolve()
})

export default navigateToOverseaShopping
